export default "__VITE_ASSET__BhsRZGbs__"